module.exports = __webpack_public_path__ + "img/clubs.d5ed0332.png";